import { kpiTypes } from "../../context/themes";
import { Tooltip, Chip } from "@mui/material";
import React from "react";

export default function KPITypeChip({ scaleType }) {
  const kpiType = kpiTypes[scaleType];
  if (!kpiType || scaleType === 2) return null;

  return (
    <Tooltip title={kpiType.description} arrow>
      <Chip sx={{cursor: "help"}} label={kpiType.label} size="small" variant="outlined" color="warning" />
    </Tooltip>
  );
}
